// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Countdown, { zeroPad } from "react-countdown";
import { setOngoingExamStatus } from "../../slices/examSlice/ongoingExam";
import { useAppDispatch } from "../../slices/store";
import { useRef } from "react";

export const CountDownTimer = (props: { time: any }) => {
  const dispatch = useAppDispatch();

  // Persist the end time across re-renders
  const endTime = useRef(Date.now() + props.time * 60 * 1000 + 500);
  const Completionist = () => <span>Exam time has ended!</span>;
  const endExam = () => {
    setTimeout(function () {
      dispatch(setOngoingExamStatus("completed"));
    }, 1000);
  };
  const renderer = ({
    hours,
    minutes,
    seconds,
    completed,
  }: {
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      endExam();
      return <Completionist />;
    } else {
      return (
        <Box
          sx={{
            position: "fixed",
            bottom: 10,
            right: "10%",
            backgroundColor: "secondary.main",
            padding: 1,
            fontSize: 20,
            borderRadius: 2,
            border: "2px solid #212a32",
            zIndex: 1000,
          }}
        >
          <Stack
            direction="row"
            justifyContent={"center"}
            alignItems={"center"}
            spacing={1}
          >
            <Typography variant="body2">Exam ends in: </Typography>
            <div translate="no">
              <Typography sx={{ fontWeight: "bold" }} variant="h6">
                {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
              </Typography>
            </div>
          </Stack>
        </Box>
      );
    }
  };

  return (
    <Countdown
      date={endTime.current}
      renderer={renderer}
    />
  );
};
